import { ProductType } from '../../../components/ticket/ticket.constants';
import { ApiRequest } from '../../api/request';
import { FileResponse } from '@fino/ng1-response/lib';

export class ReportService extends ApiRequest {
  constructor($http, $q, appConfig, fileResponseService) {
    'ngInject';
    super({ $http, $q, appConfig, fileResponseService });
  }

  ticketProgression(since, product) {
    let url = `${this.api}/aid/reports/tickets-progression`;
    if (product == ProductType.DWS) {
      url = `${this.api}/aid/reports/dws`;
    }

    return this.$http({
      method: 'GET',
      url,
      responseType: 'arraybuffer',
      params: { since },
      headers: {
        // by default nginx buffers all responses, before returning them to the client
        // which means the file will be stored in the reverse proxy before it is sent to the client.
        // for larger files this makes the download a lot slower
        // X-Accel-Buffering: no disables this behaviour
        'X-Accel-Buffering': 'no',
      },
    }).then(FileResponse.transform);
  }

  downloadTicketProgression(since, product) {
    return this.ticketProgression(since, product).then((file) =>
      this.fileResponseService.saveAs(file, 'application/csv'),
    );
  }

  bafinReport() {
    return this.$http({
      method: 'GET',
      url: `${this.api}/aid/reports/tickets-progression/bafin`,
      responseType: 'arraybuffer',
      headers: {
        // by default nginx buffers all responses, before returning them to the client
        // which means the file will be stored in the reverse proxy before it is sent to the client.
        // for larger files this makes the download a lot slower
        // X-Accel-Buffering: no disables this behaviour
        'X-Accel-Buffering': 'no',
      },
    }).then(FileResponse.transform);
  }

  downloadBafinReport() {
    return this.bafinReport().then((file) => {
      this.fileResponseService.saveAs(file, 'application/csv');
    });
  }
}
